import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { filter, map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { DataTypeComponent } from '../../../data-type-component';
import { ActionConfigDTO, FieldConfigDTO } from '../../../../../../system/system-dtos';
import { StringUtils } from '../../../../../../common/string-utils';
import { SignInService } from '../../../../../../common/services/sign-in/sign-in.service';
import { ActionModalComponent } from '../../../../../action/action-modal/action-modal.component';

@Component({
  selector: 'app-form-field-star',
  templateUrl: './star-form-field.component.html',
  styleUrls: ['./star-form-field.component.scss'],
  standalone: false,
})
export class StarFormFieldComponent extends DataTypeComponent implements OnDestroy, OnInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() data: any;

  @Input() fieldConfig: FieldConfigDTO;

  public starredBy: string[];

  public starred: boolean;

  public starredByCurrentUser: boolean;

  private action: ActionConfigDTO;

  private entity: any;

  private currentEmail = this.signInService.getCurrentUser().email;

  constructor(
    private http: HttpClient,
    private signInService: SignInService,
    private changeDetector: ChangeDetectorRef,
    private dialog: MatDialog
  ) {
    super();
  }

  ngOnDestroy() {}

  ngOnInit(): void {
    this.setStarredStatus(this.data ? this.data : []);
    if (this.fieldConfig.actions && this.fieldConfig.actions.length == 1) {
      this.action = this.fieldConfig.actions[0];
    }
  }

  setRowData(entity: any) {
    this.entity = entity;
  }

  onClick(): void {
    if (this.action) {
      const actionUrl = StringUtils.convert(this.action.url, this.entity);
      if (this.action.rows && !this.starredByCurrentUser) {
        const dialogRef = this.dialog.open(ActionModalComponent, {
          minHeight: this.action.minModalHeight,
          minWidth: this.action.minModalWidth,
          data: {
            config: this.action,
            entity: this.data,
          },
        });
        dialogRef
          .afterClosed()
          .pipe(filter((value) => value))
          .subscribe((formValues) => {
            this.sendRequest(actionUrl, { ...formValues, ...{ starred: !this.starredByCurrentUser } });
          });
      } else {
        this.sendRequest(actionUrl, { starred: !this.starredByCurrentUser });
      }
    }
  }

  sendRequest(url: string, request: any): void {
    this.http
      .post(url, request)
      .pipe(map((response) => (response instanceof Array ? response : [])))
      .subscribe((response) => {
        this.setStarredStatus(response as string[]);
      });
  }

  setStarredStatus(starredBy: string[]): void {
    this.starredByCurrentUser =
      starredBy.indexOf(this.currentEmail) != -1 || starredBy.indexOf('system@lottomart.com') != -1;
    this.starred = starredBy.length != 0;
    this.starredBy = starredBy;
    this.changeDetector.detectChanges();
  }

  starColor(): string {
    if (this.starred && this.starredByCurrentUser) {
      return 'yellow-icon';
    }
    if (this.starred) {
      return 'blue-icon';
    }
  }
}
